import React from 'react';
import { Form as FinalForm } from 'react-final-form';
import { Button, Form } from 'semantic-ui-react';
import { TextField } from '+/components';


const NotaryForm = props => (

    <FinalForm
        validate={validate}
        initialValues={props.initialValues}
        onSubmit={props.onSubmit}
        render={({ handleSubmit, submitting, pristine }) => (
            <Form onSubmit={handleSubmit}>
                <TextField name='name' label='Full Name' />
                <TextField name='commission_number' label='Commission Number' />
                <TextField name='commission_expiration' label='Commission Expiration Date' type='date'/>

                <Form.Field>
                    <Button negative onClick={() => props.setModalOpen(false)}>
                            Cancel
                    </Button>
                    <Button floated='right' positive type='submit' disabled={submitting || pristine}>
                            Submit
                    </Button>
                </Form.Field>
            </Form>
        )}
    />
);

const validate = values => {
    const errors = {};
    if (!values.name) {
        errors.name = 'Required';
    }
    if (!values.commission_number) {
        errors.commission_number = 'Required';
    }
    if (!values.commission_expiration) {
        errors.commission_expiration = 'Required';
    }

    return errors;
};


export default NotaryForm;
